import { useMemo, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import { Box, IconButton, Button } from '@mui/material';
import { AiOutlineExport } from "react-icons/ai";
import { BiMapPin } from "react-icons/bi";

// Csv export dependencies and configuration
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { mkConfig, generateCsv, download } from 'export-to-csv';

function SmartCornerDataTable({ data, setTargetMarker }) {

    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    const finalData = [];

    // Handle CSV export

    // Define the CSV configuration
    const csvConfig = mkConfig({
        fieldSeparator: ';',
        decimalSeparator: '.',
        useKeysAsHeaders: true,
        filename: `NMS_Gateways_${new Date().toLocaleString()}`,
    });

    // Define the CSV export function
    const flattenRow = (row) => {
        return {
            name: row.name || 'N/A',
            eui: row.eui || 'N/A',
            id: row.id || 'N/A',
            status: row.status || 'N/A',
            locations: row.locations || 'N/A',
        };
    };

    // Define the CSV rows export function
    const handleExportRows = (rows) => {
        const flattenedData = rows.map((row) => flattenRow(row.original));
        const csv = generateCsv(csvConfig)(flattenedData);
        download(csvConfig)(csv);
    };

    // Define the complete CSV export function
    const handleExportData = () => {
        const flattenedData = data.map((row) => flattenRow(row));
        const csv = generateCsv(csvConfig)(flattenedData);
        download(csvConfig)(csv);
    };

    useEffect(() => {
        console.log(data)

        // Object.entries(data).forEach(([domainName, domainData]) => {
        //     domainData.list.forEach((gateway) => {
        //         finalData.push({
        //             name: gateway.name,
        //             eui: gateway.lrruuid,
        //             status: gateway.status,
        //             locations: domainName
        //         });
        //     });
        // });

        console.log(finalData)

        setSuccess(true);
    }, [data]);

    // Define columns
    const columns = useMemo(
        () => [
            {
                accessorKey: 'name',
                header: 'Name',
            },
            {
                accessorKey: 'eui',
                header: 'EUI',
            },
            {
                accessorKey: 'id',
                header: 'ID',
            },
            {
                accessorKey: 'status',
                header: 'Status',
                filterVariant: 'multi-select',
                filterSelectOptions: [...new Set(data.map(item => item.status))],
                filterFn: (row, _columnId, filterValue) => {
                    if (!filterValue.length) {
                        return true;
                    }
                    const status = row.getValue('status');
                    return filterValue.includes(status);
                },
            },
            {
                accessorKey: 'locations',
                header: 'Location',
                filterVariant: 'multi-select',
                filterSelectOptions: [...new Set(data.map(item => item.locations))],
                filterFn: (row, _columnId, filterValue) => {
                    if (!filterValue.length) {
                        return true;
                    }
                    const location = row.getValue('locations');
                    return filterValue.includes(location);
                },
            }
        ],
        []
    );

    // Initialize table with `useMaterialReactTable`
    const table = useMaterialReactTable({
        data,
        columns,
        getRowId: (row) => row.eui,
        enableFilters: true,
        enableRowActions: true,
        renderRowActions: ({ row }) => (
            <Box sx={{ display: 'flex', gap: '8px' }}>
                <IconButton
                    onClick={() =>
                        window.open(`/gateways/${row.getValue('id')}/${row.original.server}`, '_blank')
                    }
                >
                    <AiOutlineExport />
                </IconButton>
                {row.original.latitude && row.original.longitude && <IconButton
                    onClick={() =>
                        setTargetMarker({
                            latitude: row.original.latitude,
                            longitude: row.original.longitude,
                        })
                    }
                >
                    <BiMapPin />
                </IconButton>}
            </Box>
        ),
        initialState: {
            showColumnFilters: true,
        },
        enableRowSelection: true,
        muiTableBodyProps: {
            sx: {
                backgroundColor: 'var(--bgPrimary)',
                color: 'var(--textPrimary)',
            },
        },
        muiTableHeadProps: {
            sx: {
                backgroundColor: 'var(--bgPrimary)',
                color: 'var(--textPrimary)',
            },
        },
        muiTableCellProps: {
            sx: {
                color: 'var(--textPrimary)',
            },
        },
    });

    return (
        <div>
            {success &&
                <>
                    <Box sx={{ display: 'flex', gap: '16px', padding: '8px', flexWrap: 'wrap' }}>
                        <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
                            Export All Data
                        </Button>
                        <Button
                            disabled={table.getPrePaginationRowModel().rows.length === 0}
                            onClick={() => handleExportRows(table.getPrePaginationRowModel().rows)}
                            startIcon={<FileDownloadIcon />}
                        >
                            Export All Rows
                        </Button>
                        <Button
                            disabled={table.getRowModel().rows.length === 0}
                            onClick={() => handleExportRows(table.getRowModel().rows)}
                            startIcon={<FileDownloadIcon />}
                        >
                            Export Page Rows
                        </Button>
                        <Button
                            disabled={!table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()}
                            onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                            startIcon={<FileDownloadIcon />}
                        >
                            Export Selected Rows
                        </Button>
                    </Box>
                    <MaterialReactTable table={table} />
                </>
            }
        </div>
    );
}

export default SmartCornerDataTable;
